'use client';

import styled from 'styled-components';

import { colors, breakpoints } from '@/styles/theme';

export const Card = styled.div`
  width: 100%;

  background-color: ${colors.light};
  border-radius: 12px;
  border: 1px solid ${colors.gray3};
  overflow: hidden;
`;

export const CardContent = styled.div`
  display: flex;

  padding: 1.5rem;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;

    gap: 16px;
  }
`;

export const GradeSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-shrink: 0;
  padding-right: 1.5rem;
  border-right: 1px solid ${colors.gray2};
  width: 120px;

  @media (max-width: ${breakpoints.mobile}) {
    padding-right: 0;
    padding-bottom: 1rem;

    border-right: none;
    border-bottom: 1px solid ${colors.gray2};
  }
`;

export const AverageGrade = styled.div`
  font-size: 3rem;
  font-weight: 600;
  color: ${colors.dark};
`;

export const TotalGrades = styled.div`
  font-size: 0.875rem;
  color: ${colors.gray5};
  margin-top: 0.25rem;
`;

export const LikesSection = styled.div`
  flex-grow: 1;
  padding-left: 1.5rem;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.9rem;
  }
`;

export const LikesTitle = styled.h3`
  font-weight: 500;
  color: ${colors.dark};
  margin-bottom: 0.75rem;
`;

export const LikesList = styled.ul`
  display: flex;
  flex-wrap: wrap;

  padding: 0;
  margin: 0;

  list-style-type: none;
`;

export const LikeItem = styled.li`
  display: flex;
  align-items: center;

  gap: 8px;
  margin-right: 16px;
  margin-bottom: 8px;
`;

export const LikeText = styled.span`
  color: ${colors.dark};
`;

export const LikeCount = styled.span`
  color: ${colors.gray5};
`;
